var $2da020247dfb25c5$exports = {};
function $2da020247dfb25c5$var$showFlyer(displayTime, flyerContainer, interval) {
    if (displayTime <= new Date()) {
        flyerContainer.style.display = 'flex';
        clearInterval(interval);
    }
    console.log("Checked");
}
const $2da020247dfb25c5$var$displayTime = new Date('2026-03-25T10:00:00');
const $2da020247dfb25c5$var$flyerContainer = document.querySelector('.tour-flyer-carousel-section');
if ($2da020247dfb25c5$var$displayTime < new Date()) $2da020247dfb25c5$var$flyerContainer.style.display = 'flex';
else {
    const interval = setInterval(()=>{
        $2da020247dfb25c5$var$showFlyer($2da020247dfb25c5$var$displayTime, $2da020247dfb25c5$var$flyerContainer, interval);
    }, 60000);
}


//# sourceMappingURL=path0.67ea91df.js.map
